<template>
  <g
    class="legend"
    :transform="
      `translate(0,${
        c.legendPosition === 'top' ? 0 : p.scaleY(p.minY) + +c.xAxisHeight
      })`
    "
  >
    <text
      x="50%"
      :y="c.legendHeight"
      text-anchor="middle"
      :fontSize="c.legendFontSize"
      :style="{ fontSize: c.legendFontSize }"
    >
      <tspan
        v-for="(serie, serieIndex) in c.series"
        :key="serieIndex"
        :style="{ fill: serie.colorPrimary }"
        >{{ serie.label }}&nbsp;{{
          p.tooltipMove && p.tooltipMove.datum
            ? p.format(+p.tooltipMove.datum[serie.key]) +
              " " +
              c.globalUnitSymbol
            : ""
        }}&nbsp;&nbsp;&nbsp;&nbsp;</tspan
      >
    </text>
  </g>
</template>

<script>
export default {
  props: ["c", "p"]
};
</script>
